import React from "react";
import { Container, Row, Col, Jumbotron } from "reactstrap";
import Button from '../Button/Button'
import styles from "./ResourcesHeader.module.scss";

const ResourceHeader = ({ image, headline, cta, linkKind, style }) => {
  const rel = cta?.linkTarget ? 'noreferrer noopener' : "";

  return (
    <div className={styles.heroWidth} style={style}>
      <Container>
        <div className={styles.containeWraperHeader}>
          <Row className={styles.containerInfo}>
            <Col className={styles.colInfo} xs={12} lg={5}>
              <div style={{ maxWidth: 500 }}>
                <h1>{headline}</h1>
                <div className={styles.containerBottomInfo}>
                  {!React.isValidElement(cta)
                    ? <a href={cta.url} rel={rel}><Button variant="secondary" {...cta} /></a>
                    : cta}
                </div>
              </div>
            </Col>
            <Col lg={{ offset: 1, size: 5 }} className={styles.imgCol}>
              <div
                className={styles.img}
                style={{ backgroundImage: `url(${image || window._edo_location_taxonomy?.image})`, backgroundSize: "cover" }}
              ></div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default ResourceHeader;
